module.exports = __webpack_public_path__ + "static/img/b23.e673e89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b23.jpg
// module id = +QIq
// module chunks = 1